import React, { useState, useEffect } from 'react';
import CommunityBoard from './CommunityBoard';
import DirectMessage from './DirectMessage';
import { useLocation } from 'react-router-dom';

const TABS = [
  { label: '📝 커뮤니티 게시판', key: 'board', gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: '#667eea' },
  { label: '💬 1:1 채팅', key: 'dm', gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)', color: '#f093fb' }
];

function Community() {
  const [tab, setTab] = useState('board');
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tabParam = params.get('tab');
    if (tabParam && ['board', 'dm'].includes(tabParam)) {
      setTab(tabParam);
    }
  }, [location.search]);

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: '40px 20px'
    }}>
      {/* 헤더 섹션 */}
      <div style={{
        textAlign: 'center',
        marginBottom: 40
      }}>
        <div style={{
          fontSize: 48,
          marginBottom: 16
        }}>
          🌈
        </div>
        <h1 style={{
          fontSize: 42,
          fontWeight: 900,
          color: '#fff',
          margin: 0,
          marginBottom: 12,
          textShadow: '0 4px 20px rgba(0,0,0,0.3)',
          letterSpacing: '-2px'
        }}>
          커뮤니티
        </h1>
        <p style={{
          fontSize: 18,
          color: 'rgba(255,255,255,0.9)',
          margin: 0,
          fontWeight: 500
        }}>
          소통하고, 친구를 만들고, 함께 성장해요!
        </p>
      </div>

      {/* 탭 메뉴 */}
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        gap: 20,
        marginBottom: 40
      }}>
        {TABS.map(t => (
          <button
            key={t.key}
            onClick={() => setTab(t.key)}
            style={{
              padding: '18px 36px',
              borderRadius: 20,
              fontWeight: 800,
              fontSize: 18,
              background: tab === t.key 
                ? 'rgba(255,255,255,1)' 
                : 'rgba(255,255,255,0.2)',
              color: tab === t.key ? t.color : '#fff',
              border: 'none',
              boxShadow: tab === t.key 
                ? '0 8px 32px rgba(255,255,255,0.3)' 
                : '0 4px 16px rgba(0,0,0,0.1)',
              cursor: 'pointer',
              letterSpacing: '-0.5px',
              transition: 'all 0.3s ease',
              transform: tab === t.key ? 'translateY(-2px)' : 'translateY(0)',
              backdropFilter: 'blur(10px)'
            }}
            onMouseEnter={(e) => {
              if (tab !== t.key) {
                e.target.style.background = 'rgba(255,255,255,0.3)';
                e.target.style.transform = 'translateY(-1px)';
              }
            }}
            onMouseLeave={(e) => {
              if (tab !== t.key) {
                e.target.style.background = 'rgba(255,255,255,0.2)';
                e.target.style.transform = 'translateY(0)';
              }
            }}
          >
            {t.label}
          </button>
        ))}
      </div>

      {/* 메인 컨텐츠 */}
      <div style={{
        maxWidth: 1200,
        margin: '0 auto',
        background: '#fff',
        borderRadius: 32,
        boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
        overflow: 'hidden',
        minHeight: 600
      }}>
        {/* 컨텐츠 헤더 */}
        <div style={{
          background: tab === 'board' 
            ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
            : 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
          padding: '24px 32px',
          color: '#fff'
        }}>
          <h2 style={{
            fontSize: 24,
            fontWeight: 700,
            margin: 0,
            display: 'flex',
            alignItems: 'center',
            gap: 12
          }}>
            {tab === 'board' ? '📝 게시판에서 자유롭게 소통하세요' : '💬 친구들과 실시간 채팅'}
          </h2>
          <p style={{
            margin: '8px 0 0 0',
            opacity: 0.9,
            fontSize: 14
          }}>
            {tab === 'board' 
              ? '공지, 길드 모집, 레슨, 운동 파트너까지 모든 소식을 한 곳에서!'
              : '친구와 1:1 채팅으로 더 가까워지세요'
            }
          </p>
        </div>

        {/* 컨텐츠 영역 */}
        <div style={{
          padding: '32px'
        }}>
          {tab === "board" && <CommunityBoard />}
          {tab === "dm" && <DirectMessage />}
        </div>
      </div>

      {/* 하단 인포 카드들 */}
      <div style={{
        maxWidth: 1200,
        margin: '40px auto 0',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: 24
      }}>
        <div style={{
          background: 'rgba(255,255,255,0.15)',
          borderRadius: 20,
          padding: 24,
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255,255,255,0.2)'
        }}>
          <div style={{ fontSize: 24, marginBottom: 12 }}>🎯</div>
          <h3 style={{
            color: '#fff',
            fontSize: 18,
            fontWeight: 700,
            margin: '0 0 8px 0'
          }}>
            스마트 매칭
          </h3>
          <p style={{
            color: 'rgba(255,255,255,0.8)',
            fontSize: 14,
            margin: 0,
            lineHeight: 1.5
          }}>
            게시판에서 운동 파트너를 찾고 MMR 기반으로 실력이 비슷한 사람들과 매칭되어 보세요!
          </p>
        </div>

        <div style={{
          background: 'rgba(255,255,255,0.15)',
          borderRadius: 20,
          padding: 24,
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255,255,255,0.2)'
        }}>
          <div style={{ fontSize: 24, marginBottom: 12 }}>🏆</div>
          <h3 style={{
            color: '#fff',
            fontSize: 18,
            fontWeight: 700,
            margin: '0 0 8px 0'
          }}>
            길드 시스템
          </h3>
          <p style={{
            color: 'rgba(255,255,255,0.8)',
            fontSize: 14,
            margin: 0,
            lineHeight: 1.5
          }}>
            같은 관심사를 가진 사람들과 길드를 만들어 정기적인 활동과 대회에 참여해보세요!
          </p>
        </div>

        <div style={{
          background: 'rgba(255,255,255,0.15)',
          borderRadius: 20,
          padding: 24,
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255,255,255,0.2)'
        }}>
          <div style={{ fontSize: 24, marginBottom: 12 }}>📈</div>
          <h3 style={{
            color: '#fff',
            fontSize: 18,
            fontWeight: 700,
            margin: '0 0 8px 0'
          }}>
            성장 추적
          </h3>
          <p style={{
            color: 'rgba(255,255,255,0.8)',
            fontSize: 14,
            margin: 0,
            lineHeight: 1.5
          }}>
            경기 기록과 통계를 통해 실력 향상을 확인하고 목표를 설정해보세요!
          </p>
        </div>
      </div>
    </div>
  );
}

export default Community;